export default __webpack_public_path__ + "static/lane_5000.png";